import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faTable, faSearch } from "@fortawesome/pro-light-svg-icons";

import { faGripLinesVertical } from "@fortawesome/pro-light-svg-icons";

import {
  faEdit,
  faPencil,
  faCircleInfo,
} from "@fortawesome/pro-regular-svg-icons";
import { ResizeEvent } from "angular-resizable-element";
import { CommonService } from "@services/common.service";

@Component({
    selector: "app-table-chart",
    templateUrl: "./table-chart.component.html",
    styleUrls: ["./table-chart.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class TableChartComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() data: any = [];
  @Input() chartData: any = [];
  @Input() dataPoints?: any = [];
  @Input() type?: string;
  @Input() fullSize?: boolean;
  @Input() preview?: boolean;
  @Input() hasEdit?: boolean = true;

  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    public commonService: CommonService,
    public parentF: FormGroupDirective
  ) {
    this.dataForm = this.fb.group({
      dataSearch: new UntypedFormControl(""),
    });
    this.chartForm = this.fb.group({
      title: new UntypedFormControl(""),
    });
  }
  dataForm: UntypedFormGroup;
  chartForm: UntypedFormGroup;
  childForm: any;

  public columns!: Array<any>;
  public displayedColumns!: Array<any>;
  public displayedHeaderColumns!: Array<any>;
  public dataSource!: any;
  public minwidth: any;
  public title: string = "";
  public description: string = "";
  faTable = faTable;
  faEdit = faEdit;
  faPencil = faPencil;
  faCircleInfo = faCircleInfo;
  displayDrilldown = true;
  drilldownLink = "http://www.quantivate.com";
  faSearch = faSearch;
  faGripLinesVertical = faGripLinesVertical;
  public featureFlags: any = [];

  nestedFilterCheck(search: any, data: any, key: any) {
    if (typeof data[key] === "object") {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  applyFilter(event: Event) {
    let filterValue;

    this.dataSource.filterPredicate = function (data: any, filter: any) {
      let dataStr = Object.keys(data)
        .reduce(function (currentTerm, key) {
          return currentTerm + data[key] + "◬";
        }, "")
        .toLowerCase();
      let transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) != -1;
    };

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const accumulator = (currentTerm: any, key: any) => {
        return this.nestedFilterCheck(currentTerm, data, key);
      };
      const dataStr = Object.keys(data).reduce(accumulator, "").toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.filter == "") {
      this.dataSource.filterPredicate = () => {
        return true;
      };
      this.dataSource.filter = true;
    }
    this.resizeData();
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
    this.childForm = this.parentF.form;
    this.getAllColumnsAndData();

    if (this.childForm)
      this.title = this.chartData.title || this.childForm.get("title").value;

    if (
      this.chartData &&
      this.chartData.modifications.data.formatters.data &&
      this.chartData.modifications.data.formatters.data.length > 0
    ) {
      this.title = this.chartData.modifications.data.formatters.data[0].value;
      if (this.chartData.modifications.data.formatters.data[1]) {
        this.description =
          this.chartData.modifications.data.formatters.data[1].value;
      }
    }
  }
  ngAfterViewInit() {
    //this.dataSource.sort = this.sort;
  }
  ngOnInit() {
    this.childForm = this.parentF.form;
    this.featureFlags = JSON.parse(sessionStorage.getItem("featureFlags"));
    let title;
    if (this.title) {
      title = this.title;
    } else {
      title =
        (this.childForm && this.childForm.controls["title"].value) ||
        (this.childForm && this.childForm.get("title").value);
    }

    this.chartForm.get("title")?.setValue(title);
    this.getAllColumnsAndData();
  }

  onResizeEnd(event: ResizeEvent, columnName: any): void {
    //on resize of the header columns
    columnName = this.commonService.sanitizeColumn(columnName);
    if (event.edges.right) {
      const cssValue = event.rectangle.width + "px";
      const columnElts = document.getElementsByClassName(
        "mat-column-" + columnName.split(" ").join("-")
      );
      for (let i = 0; i < columnElts.length; i++) {
        const currentEl = columnElts[i] as HTMLDivElement;
        currentEl.style.width = cssValue;
      }
    }
  }

  resizeData() {
    setTimeout(() => {
      this.displayedColumns.forEach((col: any) => {
        col = this.commonService.sanitizeColumn(col);
        const columnElts = document.getElementsByClassName(
          "mat-column-" + col.split(" ").join("-")
        );
        let temp = columnElts[0] as HTMLDivElement;
        let cssValue = "300px";

        if (temp && temp.style && temp.style.width) {
          cssValue = temp.style.width;
        }
        for (let i = 1; i < columnElts.length; i++) {
          const currentEl = columnElts[i] as HTMLDivElement;
          currentEl.style.width = cssValue;
        }
      });
    }, 10);
  }
  resizeConfig(col: number) {
    let retval;
    if (col == 1) {
      retval = { right: true };
    } else {
      retval = { right: true, left: true };
    }
    return retval;
  }
  displayHeader(col: any) {
    const result = this.dataPoints.data.filter(
      (header: any) => header.id == col
    );
    if (result && result.length > 0) {
      return result[0].name;
    } else {
      return col;
    }
  }

  getAllColumnsAndData() {
    if (this.data && typeof this.data != "string") {
      // Get list of columns by gathering unique keys of objects found in DATA.

      const columns = this.data
        .reduce((columns: any, row: {}) => {
          return [...columns, ...Object.keys(row)];
        }, [])
        .reduce((columns: string | any[], column: any) => {
          return columns.includes(column) ? columns : [...columns, column];
        }, []);
      // Describe the columns for <mat-table>.
      this.columns = columns.map((column: string) => {
        return {
          //columnDef: column.split(" ").join("-"),
          columnDef: column,
          header: column,
          cell: (element: any) => `${element[column] ? element[column] : ``}`,
        };
      });
      // sets the displayed columns
      this.displayedColumns = this.columns.map((c) => c.columnDef);
      //rename headerColumns
      this.displayedHeaderColumns = this.displayedColumns;
      // this.displayedHeaderColumns = [];
      // this.displayedColumns.forEach((headerItem: any) => {
      //   this.displayedHeaderColumns.push(this.displayHeader(headerItem));
      // });
      // Set the dataSource for <mat-table>.
      this.dataSource = new MatTableDataSource(<any>this.data);
      this.dataSource.paginator = this.paginator;
      setTimeout(() => {
        this.dataSource.sort = this.sort;
      }, 10);
      this.resizeData();
    }
  }
}
